import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
  inject,
} from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';
import type { IconSvgObject } from '@hugeicons/angular';

@Component({
  selector: 'hugeicons-icon',
  standalone: true,
  template: `<div class="icon" [innerHTML]="safeSvgElement()"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HugeiconsIconComponent {
  private sanitizer = inject(DomSanitizer);
  icon = input.required<IconSvgObject>();
  size = input<string | number>(24);
  strokeWidth = input<number | undefined>(undefined);
  color = input<string>('currentColor');
  class = input<string>('');

  private camelToKebab(str: string): string {
    return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
  }

  svgElement = computed(() => {
    const sizeStr = this.size().toString();
    const currentIcon = this.icon();
    const sw = this.strokeWidth();

    let children = '';
    for (let i = 0; i < currentIcon.length; i++) {
      const path = currentIcon[i];
      const tag = path[0];
      const attributes = path[1];
      const attributeKeys = Object.keys(attributes);

      let attrs = '';
      for (let y = 0; y < attributeKeys.length; y++) {
        const key = this.camelToKebab(attributeKeys[y]);
        const val = attributes[attributeKeys[y]];
        attrs += ` ${key}="${val}"`;
      }

      const fill = attributes['fill'] || 'none';
      const strokeWidthVal = sw ?? attributes['strokeWidth'];

      attrs += ` fill="${fill}"`;
      if (strokeWidthVal !== undefined) {
        attrs += ` stroke-width="${strokeWidthVal}"`;
      }

      children += `<${tag}${attrs}></${tag}>`;
    }

    return `<svg width="${sizeStr}" height="${sizeStr}" viewBox="0 0 24 24" fill="none" color="${this.color()}" class="${this.class()}" xmlns="http://www.w3.org/2000/svg">${children}</svg>`;
  });

  safeSvgElement = computed<SafeHtml>(() => {
    return this.sanitizer.bypassSecurityTrustHtml(this.svgElement());
  });
}
